import { IconWrapper } from '../runtime';
export default IconWrapper('list-view', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M9.75 2.24973H14.25M9.75 5.74973H14.25M9.75 10.2497H14.25M9.75 13.7497H14.25M2.05 6.24976H5.95C6.11569 6.24976 6.25 6.11544 6.25 5.94976V2.04976C6.25 1.88407 6.11569 1.74976 5.95 1.74976H2.05C1.88431 1.74976 1.75 1.88407 1.75 2.04976V5.94976C1.75 6.11544 1.88431 6.24976 2.05 6.24976ZM2.05 14.2498H5.95C6.11569 14.2498 6.25 14.1154 6.25 13.9498V10.0498C6.25 9.88407 6.11569 9.74976 5.95 9.74976H2.05C1.88431 9.74976 1.75 9.88407 1.75 10.0498V13.9498C1.75 14.1154 1.88431 14.2498 2.05 14.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});